import { render, staticRenderFns } from "./EditLiveAddStageTab.vue?vue&type=template&id=d97a8dda"
import script from "./EditLiveAddStageTab.vue?vue&type=script&lang=js"
export * from "./EditLiveAddStageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports